import CreateEditOrganizationModal from "./CreateEditOrganizationModal";
import { useInsertHierachySuborgMutation } from '../../utilities/mutations/useInsertHierachySuborgMutation';
import { useUpdateHierachySuborgMutation } from '../../utilities/mutations/useUpdateHierachySuborgMutation';
import { errorToast, successToast } from '../../constants/toast';
import { LocationModalContext } from "../../utilities/Contexts/LocationModalContext";
import { useContext} from "react";

export default function CreateEditOrganizationModalViewModel({ isOpen, parentId, accountId, name, onComplete, makeToast }) {

    const { expandParentNodeAfterAddingData, expandedItems } = useContext(LocationModalContext);
    const isCreate = accountId == null;
    const successCall = () => {
        makeToast(isCreate ? "Organization Created" : "Organization updated", successToast);
        onComplete();
    };

    const failedCall = () => {
        makeToast(isCreate ? "Error Creating Organization" : "Error updating Organization", errorToast);
    };


    const { isPending: isInsertLoading, mutateAsync: insertAsync, error: insertError, reset: insertReset } = useInsertHierachySuborgMutation();
    const { isPending: isUpdateLoading, mutateAsync: updateAsync, error: updateError, reset: updateReset } = useUpdateHierachySuborgMutation();

    const hasError = insertError || updateError;
    const isLoading = isInsertLoading || isUpdateLoading;

    const checkForNull = (x) => x?.response?.data === null || x?.response?.data === undefined || x?.response?.data?.trim() === '';
    let errorMessage = '';
    if (hasError) {
        if (!checkForNull(updateError)) {
            errorMessage = updateError.response.data;
        }
        else if (!checkForNull(insertError)) {
            errorMessage = insertError.response.data;
        }
        else {
            errorMessage = 'An error has occurred while saving. Please try again later.'
        }
    }

    const handleCreate = async (event) =>
    {
        event.preventDefault();
        if (event?.target?.name?.value?.trim()?.length === 0) {
            const toastMsg = 'Please enter a valid name';
            makeToast(toastMsg, errorToast);
            return;
        }

        if (isCreate) {
            await insertAsync({ parentId, name: event.target.name.value }, { onError: failedCall, onSuccess: successCall });
            expandParentNodeAfterAddingData(parentId.toString());
        }
        else {
            await updateAsync({ accountId, parentId, name: event.target.name.value }, { onError: failedCall, onSuccess: successCall });
        }
    }

    const suborgData = {
        name,
        accountId
    }

    const cancelHandler = (event) => {
        event.preventDefault();
        insertReset();
        updateReset();
        onComplete();
    }

    return (
        <CreateEditOrganizationModal
            onSave={handleCreate}
            onCancel={cancelHandler}
            isCreate={isCreate}
            isOpen={isOpen}
            hasError={hasError}
            isLoading={isLoading}
            suborgData={suborgData}
            errorMessage={errorMessage}>
            
        </CreateEditOrganizationModal>
    )
}